import { useMutation, useQueryClient } from "@tanstack/react-query";
import { superAdminApi } from "../../api/superadmin";
import { superAdminKeys } from "../queries/useSuperAdmin";
import { tournamentKeys } from "../queries/useTournament";
import { playerKeys } from "../queries/usePlayer";

export const useUpdateTournament = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: superAdminApi.updateTournament,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: superAdminKeys.all });
      queryClient.invalidateQueries({ queryKey: tournamentKeys.detail(variables.tournamentId) });
      queryClient.invalidateQueries({ queryKey: tournamentKeys.list() });
    },
  });
};

export const useSetPlayerUserLink = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: superAdminApi.setPlayerUserLink,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: superAdminKeys.all });
      queryClient.invalidateQueries({ queryKey: playerKeys.detail(variables.playerId) });
    },
  });
};
